const CreateCommunicationService = require('services/communication');

module.exports = (context) => CreateCommunicationService.fromContext(context);
